import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "font-semibold bg-yellow-200 rounded px-4 py-2"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-red-200 rounded px-4 py-2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "Payroll information is historical", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row justify-between items-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Payment breakdown (USD)", -1)
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row justify-between items-center bg-primary-background rounded-2xl px-4 py-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "You're now editing this candidate profile", -1)
const _hoisted_11 = { class: "flex flex-col mt-4" }
const _hoisted_12 = { class: "flex flex-row mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Total Compensation / Month")
], -1)
const _hoisted_14 = { class: "font-semibold ml-4" }
const _hoisted_15 = { class: "flex flex-row mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Salary / Month")
], -1)
const _hoisted_17 = { class: "ml-4" }
const _hoisted_18 = { class: "flex flex-col mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_20 = { class: "flex flex-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize ml-4" }, "Gross Salary")
], -1)
const _hoisted_22 = { class: "text-gray-500 ml-4" }
const _hoisted_23 = { class: "flex flex-col mt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_25 = { class: "flex flex-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 capitalize ml-4" }, "Employer Taxes")
], -1)
const _hoisted_27 = { class: "text-gray-500 ml-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_29 = { class: "flex flex-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Benefits / Month")
], -1)
const _hoisted_31 = { class: "ml-4" }
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "mt-2" }, "All benefit amounts are in USD", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_35 = { class: "flex flex-row" }
const _hoisted_36 = { class: "w-72 mr-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_38 = { class: "flex flex-row items-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-gray-500",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_40 = {
  key: 0,
  class: "text-gray-400 italic ml-4"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "ENTER ", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" to create ")
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "mt-4" }, "All benefit amounts are in USD", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-2" }, null, -1)
const _hoisted_46 = { class: "flex flex-row" }
const _hoisted_47 = { class: "w-72" }
const _hoisted_48 = { class: "text-gray-500 capitalize ml-4" }
const _hoisted_49 = { class: "text-gray-500 ml-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_51 = { class: "flex flex-row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Christmas Bonus / Month")
], -1)
const _hoisted_53 = { class: "ml-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_55 = { class: "flex flex-row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Axelerate Fees / Month")
], -1)
const _hoisted_57 = { class: "ml-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_59 = { class: "flex flex-row my-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Total Annual Compensation")
], -1)
const _hoisted_61 = { class: "font-semibold ml-4" }
const _hoisted_62 = { class: "flex flex-row mt-4" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Annual Salary")
], -1)
const _hoisted_64 = { class: "ml-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_66 = { class: "flex flex-row" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Annual Benefits")
], -1)
const _hoisted_68 = { class: "ml-4" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_70 = { class: "flex flex-row" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Christmas Bonus")
], -1)
const _hoisted_72 = { class: "ml-4" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_74 = { class: "flex flex-row" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "w-72" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Total Annual Axelerate Fees")
], -1)
const _hoisted_76 = { class: "ml-4" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_CurrencyFieldSimple = _resolveComponent("CurrencyFieldSimple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.talent.talent.position)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " You must add a role to the talent in order to see payment breakdown. "))
      : (_ctx.talent.talent.status === 'inactive')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!_ctx.editing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args))),
                    class: "border-2 border-primary rounded-full text-primary px-4 py-2"
                  }, " Edit ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.finishEditing && _ctx.finishEditing(...args))),
                    class: "rounded-full bg-primary text-white px-6 py-2"
                  }, " Done editing ")
                ]))
          ])),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", _hoisted_14, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 2 +
                _ctx.info.employer_taxes * 2 +
                _ctx.info.benefits_total * 2 +
                _ctx.info.christmas_bonus * 2 +
                _ctx.info.axelerate_percent * 2) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("span", _hoisted_17, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 2 + _ctx.info.employer_taxes * 2) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, " $" + _toDisplayString(((_ctx.info.gross_salary * 2) / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("span", _hoisted_27, " $" + _toDisplayString(((_ctx.info.employer_taxes * 2) / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1)
        ])
      ]),
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("span", _hoisted_31, " $" + _toDisplayString(((_ctx.info.benefits_total * 2) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _hoisted_33,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBenefits, (val, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "flex flex-col mt-2"
              }, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_TextField, {
                      modelValue: _ctx.allBenefits[i].name,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.allBenefits[i].name) = $event),
                      label: "Name",
                      name: `allBenefits[${i}].name`,
                      typeInput: "text"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                  ]),
                  _createVNode(_component_CurrencyFieldSimple, {
                    modelValue: _ctx.allBenefits[i].value,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.allBenefits[i].value) = $event),
                    class: "bg-background rounded px-4 py-4 ml-4"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ])
              ]))
            }), 128)),
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newBenefitName) = $event)),
                placeholder: "New item",
                type: "text",
                class: "bg-background rounded px-4 py-4 focus:outline-none"
              }, null, 512), [
                [_vModelText, _ctx.newBenefitName]
              ]),
              (_openBlock(), _createBlock(_component_CurrencyFieldSimple, {
                key: _ctx.updateField,
                onKeyup: _withKeys(_ctx.pushBenefit, ["enter"]),
                modelValue: _ctx.newBenefitValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newBenefitValue) = $event)),
                class: "bg-background rounded px-4 py-4 ml-4"
              }, null, 8, ["onKeyup", "modelValue"])),
              (_ctx.newBenefitName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _hoisted_43))
                : _createCommentVNode("", true)
            ]),
            _hoisted_44
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.info.benefits, (val, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "flex flex-col mt-2"
            }, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(val.name), 1)
                ]),
                _createElementVNode("span", _hoisted_49, " $" + _toDisplayString((val.value / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1)
              ])
            ]))
          }), 128)),
      _hoisted_50,
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _createElementVNode("span", _hoisted_53, " $" + _toDisplayString(((_ctx.info.christmas_bonus * 2) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_54,
      _createElementVNode("div", _hoisted_55, [
        _hoisted_56,
        _createElementVNode("span", _hoisted_57, " $" + _toDisplayString(((_ctx.info.axelerate_percent * 2) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_58,
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _createElementVNode("span", _hoisted_61, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 24 +
                _ctx.info.employer_taxes * 24 +
                _ctx.info.benefits_total * 24 +
                _ctx.info.christmas_bonus * 24 +
                _ctx.info.axelerate_percent * 24) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("span", _hoisted_64, " $" + _toDisplayString((
              (_ctx.info.gross_salary * 24 + _ctx.info.employer_taxes * 24) /
              100
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_65,
      _createElementVNode("div", _hoisted_66, [
        _hoisted_67,
        _createElementVNode("span", _hoisted_68, " $" + _toDisplayString(((_ctx.info.benefits_total * 24) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_69,
      _createElementVNode("div", _hoisted_70, [
        _hoisted_71,
        _createElementVNode("span", _hoisted_72, " $" + _toDisplayString(((_ctx.info.christmas_bonus * 24) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_73,
      _createElementVNode("div", _hoisted_74, [
        _hoisted_75,
        _createElementVNode("span", _hoisted_76, " $" + _toDisplayString(((_ctx.info.axelerate_percent * 24) / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1)
      ]),
      _hoisted_77
    ])
  ]))
}